/* FLC AnywherePOD cart-preview guard (draft theme). Rebuilds the cart preview from the
   saved personalization so the cart image always shows the flower and name the
   customer actually chose, even when Add To Cart is pressed before AnywherePOD's
   preview finished loading the new flower image. Order data is untouched. */
(function () {
  if (window.FLCApodGuard) return;
  var CFG = {"bg":{"left":0,"top":0,"width":1944,"height":1944,"scaleX":0.25720165,"scaleY":0.25720165,"angle":0,"flipX":false,"flipY":false,"opacity":1,"originX":"left","originY":"top","cropX":0,"cropY":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/artwork/1/f34fc21b-a3c0-4ef4-b146-3b28748b1e8e.png","visible":true,"skewX":0,"skewY":0,"globalCompositeOperation":"source-over"},"ov":{"left":0,"top":0,"width":1944,"height":1944,"scaleX":0.25720165,"scaleY":0.25720165,"angle":0,"flipX":false,"flipY":false,"opacity":1,"originX":"left","originY":"top","cropX":0,"cropY":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/artwork/1/48de3d99-d657-46d6-91cf-a421ff354209.png","visible":true,"skewX":0,"skewY":0,"globalCompositeOperation":"source-over"},"art":{"1459793":[{"id":"image1","left":120.62757161342742,"top":126.77432586722742,"width":500,"height":500,"scaleX":0.5038407216122903,"scaleY":0.5038407216122903,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/previewThumb/13558/d324ded7-81da-406a-9f5b-70ccbaae846f.png","type":"image"},{"id":"clipart2","left":130.447299734218,"top":157.35381154801075,"width":1024,"height":1536,"scaleX":0.0637251293494784,"scaleY":0.0637251293494784,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/5dc5c67e-d700-48ff-ad2c-d825945812b0.png","type":"image"},{"id":"text3","left":152.9161286188267,"top":338.91507246843355,"width":169.76199585,"height":39.324,"scaleX":0.50384072,"scaleY":0.50384072,"angle":-90,"fill":"#000000","fontFamily":"libre_baskerville-italic","fontSize":15.115221600000003,"text":"JESSICA","textAlign":"right","paintFirst":"stroke","uppercase":true,"dynamicSizing":true,"verticalAlign":"middle","isArc":false,"fontUrl":"https://fonts.gstatic.com/s/librebaskerville/v5/QHIOz1iKF3bIEzRdDFaf5QnhapNS5Oi8FPrBRDLbsW4.ttf","type":"text"}],"1459902":[{"id":"image1","left":120.6275720165,"top":126.7743262703,"width":500,"height":500,"scaleX":0.5038407216122903,"scaleY":0.5038407216122903,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/previewThumb/13558/61516e30-eace-40dc-bd92-4b611f592e00.png","type":"image"},{"id":"clipart2","left":128.4241585359906,"top":161.29537642986662,"width":1024,"height":1536,"scaleX":0.0634974034208528,"scaleY":0.0634974034208528,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/5dc5c67e-d700-48ff-ad2c-d825945812b0.png","type":"image"},{"id":"text3","left":149.455524188308,"top":341.23084024549667,"width":169.76199585,"height":44.5672,"scaleX":0.50384072,"scaleY":0.50384072,"angle":-90,"fill":"#000000","fontFamily":"libre_baskerville","fontSize":17.130584480000003,"text":"JESSICA","textAlign":"right","paintFirst":"stroke","uppercase":true,"dynamicSizing":true,"verticalAlign":"middle","isArc":false,"fontUrl":"https://fonts.gstatic.com/s/librebaskerville/v5/pR0sBQVcY0JZc_ciXjFsKyyZRYCSvpCzQKuMWnP5NDY.ttf","type":"text"}],"1462218":[{"id":"image1","left":120.62757161342742,"top":121.88805445085056,"width":500,"height":500,"scaleX":0.5038407216122903,"scaleY":0.5038407216122903,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/previewThumb/13558/9b6dee1b-763e-49ed-a32a-4b30e843038d.png","type":"image"},{"id":"text2","left":143.66610479351507,"top":343.4163381855388,"width":182.9199987,"height":44.5672,"scaleX":0.50384072,"scaleY":0.50384072,"angle":-90,"fill":"#000000","fontFamily":"libre_baskerville","fontSize":17.130584480000003,"text":"JESSICA","textAlign":"right","paintFirst":"stroke","uppercase":true,"dynamicSizing":true,"verticalAlign":"middle","isArc":false,"fontUrl":"https://fonts.gstatic.com/s/librebaskerville/v5/pR0sBQVcY0JZc_ciXjFsKyyZRYCSvpCzQKuMWnP5NDY.ttf","type":"text"},{"id":"clipart3","left":124.4345611478504,"top":162.50329306478332,"width":1024,"height":1536,"scaleX":0.0599821268710416,"scaleY":0.0599821268710416,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/5dc5c67e-d700-48ff-ad2c-d825945812b0.png","type":"image"}],"1462802":[{"id":"image1","left":120.6275720165,"top":126.7743262703,"width":500,"height":500,"scaleX":0.5038407216122903,"scaleY":0.5038407216122903,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/previewThumb/13558/19028b95-f7cf-4d2a-931b-d289289f2b6e.png","type":"image"},{"id":"text2","left":146.3829983765738,"top":328.7060548988402,"width":149.19173386,"height":44.5672,"scaleX":0.50384072,"scaleY":0.50384072,"angle":-90,"fill":"#000000","fontFamily":"libre_baskerville","fontSize":17.13055380202547,"text":"JESSICA","textAlign":"right","paintFirst":"stroke","uppercase":true,"dynamicSizing":true,"verticalAlign":"middle","isArc":false,"fontUrl":"https://fonts.gstatic.com/s/librebaskerville/v5/pR0sBQVcY0JZc_ciXjFsKyyZRYCSvpCzQKuMWnP5NDY.ttf","type":"text"},{"id":"clipart3","left":120.6275720165,"top":145.6047400338976,"width":1024,"height":1536,"scaleX":0.0727313628339936,"scaleY":0.0727313628339936,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/5dc5c67e-d700-48ff-ad2c-d825945812b0.png","type":"image"}],"1463029":[{"id":"image1","left":120.62757161342742,"top":126.77432586722742,"width":500,"height":500,"scaleX":0.5038407216122903,"scaleY":0.5038407216122903,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/previewThumb/13558/16448849-0a91-471f-b8d4-48cc6b699143.png","type":"image"},{"id":"clipart3","left":120.62757161342742,"top":146.19406183638165,"width":1024,"height":1536,"scaleX":0.0754480115353472,"scaleY":0.0754480115353472,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/5dc5c67e-d700-48ff-ad2c-d825945812b0.png","type":"image"},{"id":"text4","left":145.99595194604194,"top":337.113580340639,"width":151,"height":46,"scaleX":0.50384072,"scaleY":0.50384072,"angle":-90,"fill":"#000000","fontFamily":"libre_baskerville","fontSize":17.681319133353682,"text":"LINDA","textAlign":"right","paintFirst":"stroke","uppercase":true,"dynamicSizing":true,"verticalAlign":"middle","isArc":false,"fontUrl":"https://fonts.gstatic.com/s/librebaskerville/v5/pR0sBQVcY0JZc_ciXjFsKyyZRYCSvpCzQKuMWnP5NDY.ttf","type":"text"}],"1463395":[{"id":"image1","left":120.6275720165,"top":126.7743262703,"width":500,"height":500,"scaleX":0.5038407216122903,"scaleY":0.5038407216122903,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/previewThumb/13558/96c56b9f-82db-44f7-9007-3753a12b419d.png","type":"image"},{"id":"text2","left":146.25626911394517,"top":329.58733507148185,"width":150,"height":45,"scaleX":0.50384072,"scaleY":0.50384072,"angle":-90,"fill":"#000000","fontFamily":"libre_baskerville","fontSize":17.29694263045469,"text":"LINDA","textAlign":"right","paintFirst":"stroke","uppercase":true,"dynamicSizing":true,"verticalAlign":"middle","isArc":false,"fontUrl":"https://fonts.gstatic.com/s/librebaskerville/v5/pR0sBQVcY0JZc_ciXjFsKyyZRYCSvpCzQKuMWnP5NDY.ttf","type":"text"},{"id":"clipart3","left":121.22775036216709,"top":147.48410777858464,"width":1024,"height":1536,"scaleX":0.07151729311986,"scaleY":0.07151729311986,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/5dc5c67e-d700-48ff-ad2c-d825945812b0.png","type":"image"}],"1463497":[{"id":"image1","left":122.94333979356311,"top":126.77432586722742,"width":500,"height":500,"scaleX":0.5038407216122903,"scaleY":0.5038407216122903,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/previewThumb/13558/93fd8b64-3489-451a-bfae-3d4d000efff3.png","type":"image"},{"id":"text2","left":149.1686769597967,"top":332.1284065175635,"width":162.00000229,"height":45,"scaleX":0.50384072,"scaleY":0.50384072,"angle":-90,"fill":"#000000","fontFamily":"libre_baskerville","fontSize":15.115221600110251,"text":"BARBARA","textAlign":"right","paintFirst":"stroke","uppercase":true,"dynamicSizing":true,"verticalAlign":"middle","isArc":false,"fontUrl":"https://fonts.gstatic.com/s/librebaskerville/v5/pR0sBQVcY0JZc_ciXjFsKyyZRYCSvpCzQKuMWnP5NDY.ttf","type":"text"},{"id":"clipart3","left":125.43601121682403,"top":147.41103607134428,"width":1024,"height":1536,"scaleX":0.06898633491586241,"scaleY":0.06898633491586241,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/5dc5c67e-d700-48ff-ad2c-d825945812b0.png","type":"image"}],"1463478":[{"id":"image1","left":120.62757161342742,"top":130.24797793337547,"width":500,"height":500,"scaleX":0.5038407216122903,"scaleY":0.5038407216122903,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/previewThumb/13558/f1709960-3c1a-48c7-8c0a-bcf1aeabebef.png","type":"image"},{"id":"text2","left":148.99666921448966,"top":332.9640176654695,"width":182.9199987,"height":44.5672,"scaleX":0.50384072,"scaleY":0.50384072,"angle":-90,"fill":"#000000","fontFamily":"libre_baskerville","fontSize":17.067137508386633,"text":"BARBARA","textAlign":"right","paintFirst":"stroke","uppercase":true,"dynamicSizing":true,"verticalAlign":"middle","isArc":false,"fontUrl":"https://fonts.gstatic.com/s/librebaskerville/v5/pR0sBQVcY0JZc_ciXjFsKyyZRYCSvpCzQKuMWnP5NDY.ttf","type":"text"},{"id":"clipart3","left":124.73750623851791,"top":135.4385209169986,"width":1024,"height":1536,"scaleX":0.0698016953146312,"scaleY":0.0698016953146312,"angle":0,"src":"https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/5dc5c67e-d700-48ff-ad2c-d825945812b0.png","type":"image"}]}};
  // Birth Flowers clip-art collection 11151 (AnywherePOD file id -> image). Used on pages
  // where AnywherePOD's own clip-art list is not loaded (cart, drawer).
  var CLIP_BASE = 'https://dc4h90zrm0wr3.cloudfront.net/clipArt/13558/';
  var CLIPS = {"171582":"04299cde-830a-4a88-8cf7-fd68abb9689c.png","171583":"defa1a99-2b0c-4b46-a3a6-1886152dd5b6.png","171584":"d34a8ba4-59a5-488a-9d9d-4b77e0706e2b.png","171585":"e791306f-b6c0-4c73-bbaf-1a014d8f44b9.png","171586":"26a47082-5faa-4612-b764-d983fd785c49.png","171587":"5dc5c67e-d700-48ff-ad2c-d825945812b0.png","175385":"e4555810-6e84-4b32-b069-5d9ae9e7a8b3.png","175386":"d6683f1e-abd5-4dc9-a65e-0260bb86a2b5.png","175387":"4f0c8056-0685-4b5d-b4fc-91ad7b280150.png","175388":"d5c6c7a5-038d-4e66-8c77-cad41d4a378c.png","171592":"fafef67a-497b-43b3-a8eb-a058cba41714.png","175389":"851ffd96-f1ba-40dc-becb-d5f19a38eebf.png"};
  var ORIGIN = 'https://app.anywherepod.com';
  var FABRIC_URL = 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1/fabric.min.js';
  var OUT_MULT = 1.2;          // 600px cart preview
  var SAFETY_MS = 25000;       // only used if the network never answers
  var KEYS = 'flc_apod_thumb_keys';
  var fabricP = null, fonts = {};
  var stats = (window.FLCApodGuard = { version: 1, last: null });

  function loadFabric() {
    if (window.fabric && window.fabric.StaticCanvas) return Promise.resolve(window.fabric);
    if (fabricP) return fabricP;
    fabricP = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = FABRIC_URL; s.async = true;
      s.onload = function () { window.fabric ? res(window.fabric) : rej(new Error('fabric missing')); };
      s.onerror = function () { fabricP = null; rej(new Error('fabric failed')); };
      document.head.appendChild(s);
    });
    return fabricP;
  }
  function patch(fabric) {
    if (fabric.Text.prototype._flcVAlign) return;
    var orig = fabric.Text.prototype._getTopOffset;
    fabric.Text.prototype._getTopOffset = function () {
      var n = orig.call(this), v = this.verticalAlign;
      if (this.type !== 'text' || this.path || (v !== 'middle' && v !== 'bottom')) return n;
      var c = this.height - this.calcTextHeight();
      return !isFinite(c) || c <= 0 ? n : n + (v === 'bottom' ? c : c / 2);
    };
    fabric.Text.prototype._flcVAlign = true;
  }
  function font(family, url) {
    var k = family + '|' + url;
    if (!fonts[k]) {
      fonts[k] = new FontFace(family, 'url(' + url + ')').load().then(function (f) { document.fonts.add(f); return f; });
      fonts[k].catch(function () { delete fonts[k]; });
    }
    return fonts[k];
  }
  function img(url) {
    return new Promise(function (res, rej) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { (i.decode ? i.decode().catch(function () {}) : Promise.resolve()).then(function () { res(i); }); };
      i.onerror = function () { rej(new Error('image ' + url)); };
      i.src = url;
    });
  }
  function fimg(fabric, json, url) {
    return img(url).then(function (el) {
      var o = Object.assign({}, json); delete o.src; delete o.type;
      return new fabric.Image(el, o);
    });
  }
  // Mirrors AnywherePOD: restore saved box, then updateObjProperty('text') + doUpdateTextSize.
  function text(fabric, o, value) {
    var t = new fabric.Text(String(o.text || ''), Object.assign({}, o));
    t.set({ width: o.width, height: o.height });
    if (value === undefined) return t;
    if (t.uppercase) value = String(value).toUpperCase();
    var w = t.width, h = t.height;
    t.set('text', value); t.set({ width: w, height: h });
    var n = t.height * t.scaleY, bw = t.width * t.scaleX, size = t.fontSize;
    if (t.dynamicSizing && !t.isArc) {
      t.initDimensions();
      var c = t.__lineWidths && t.__lineWidths[0], a = t.__lineHeights && t.__lineHeights[0];
      if (c > 0 && a > 0) size = Math.min((bw / c) * t.fontSize, (n / a) * t.fontSize);
    }
    t.set({ fontSize: size, scaleX: 1, scaleY: 1 }); t.set({ height: n, width: bw }); t.setCoords();
    return t;
  }
  function render(objects, values, mult) {
    return loadFabric().then(function (fabric) {
      patch(fabric);
      return Promise.all(objects.filter(function (o) { return o.type === 'text' && o.fontUrl; })
        .map(function (o) { return font(o.fontFamily, o.fontUrl); })).then(function () {
        var canvas = new fabric.StaticCanvas(document.createElement('canvas'), { width: 500, height: 500, enableRetinaScaling: false });
        return Promise.all([
          fimg(fabric, CFG.bg, CFG.bg.src), fimg(fabric, CFG.ov, CFG.ov.src),
          Promise.all(objects.map(function (o) {
            if (o.type === 'image') return fimg(fabric, o, (o.id in values) ? values[o.id] : o.src);
            if (o.type === 'text') return Promise.resolve(text(fabric, o, values[o.id]));
            return Promise.reject(new Error('unsupported ' + o.type));
          }))
        ]).then(function (r) {
          canvas.setBackgroundImage(r[0]); canvas.setOverlayImage(r[1]);
          r[2].forEach(function (x) { canvas.add(x); });
          canvas.renderAll();
          var out = canvas.toCanvasElement(mult);
          canvas.dispose();
          return out;
        });
      });
    });
  }
  function clipUrl(clipArtId, fileId) {
    var lib = typeof apodClipArt !== 'undefined' ? apodClipArt : null;
    var set = lib && (lib[clipArtId] || lib[String(clipArtId)]);
    var files = set ? set.clip_art_files : [];
    for (var i = 0; i < files.length; i++) if (String(files[i].id) === String(fileId)) return files[i].url;
    return CLIPS[String(fileId)] ? CLIP_BASE + CLIPS[String(fileId)] : null;
  }
  // Compares AnywherePOD's preview with ours. Differences inside the flower or name areas are
  // the known stale-preview race; differences elsewhere mean our stored layout is out of date.
  function compare(ours, theirs, rects) {
    var W = ours.width, H = ours.height, c = document.createElement('canvas');
    c.width = W; c.height = H;
    var x = c.getContext('2d'); x.drawImage(theirs, 0, 0, W, H);
    var A = x.getImageData(0, 0, W, H).data, B = ours.getContext('2d').getImageData(0, 0, W, H).data;
    var inn = 0, inT = 0, out = 0, outT = 0;
    for (var y = 0; y < H; y++) for (var X = 0; X < W; X++) {
      var i = (y * W + X) * 4;
      var d = (Math.abs(A[i] - B[i]) + Math.abs(A[i + 1] - B[i + 1]) + Math.abs(A[i + 2] - B[i + 2])) / 3;
      var inside = rects.some(function (r) { return X >= r[0] && X <= r[2] && y >= r[1] && y <= r[3]; });
      if (inside) { inT++; if (d > 40) inn++; } else { outT++; if (d > 40) out++; }
    }
    return { inside: inT ? inn / inT : 0, outside: outT ? out / outT : 0 };
  }
  function remember(key) {
    try {
      var list = JSON.parse(localStorage.getItem(KEYS) || '[]');
      list.push(key);
      while (list.length > 40) { var old = list.shift(); localStorage.removeItem(old); }
      localStorage.setItem(KEYS, JSON.stringify(list));
    } catch (e) {}
  }

  // Resolves the layout for one artwork from saved values: { objects, resolved, rects }.
  function plan(art, values) {
    var objects = art && CFG.art[art];
    if (!objects) return null; // not a dish we manage: leave untouched
    var resolved = {}, rects = [];
    objects.forEach(function (o) {
      if (!(o.id in values)) return;
      if (o.type === 'image' && /^clipart/.test(o.id)) {
        var url = clipUrl(o.clipArtId || '11151', values[o.id]);
        if (!url) throw new Error('unknown clip art ' + values[o.id]);
        resolved[o.id] = url;
        rects.push([o.left * OUT_MULT - 3, o.top * OUT_MULT - 3, (o.left + o.width * o.scaleX) * OUT_MULT + 3, (o.top + o.height * o.scaleY) * OUT_MULT + 3]);
      } else if (o.type === 'text') {
        resolved[o.id] = values[o.id];
        var tw = o.width * o.scaleX, th = o.height * o.scaleY, P = 6;
        var box = o.angle === -90 ? [o.left, o.top - tw, o.left + th, o.top] : [o.left, o.top, o.left + tw, o.top + th];
        rects.push([box[0] * OUT_MULT - P, box[1] * OUT_MULT - P, box[2] * OUT_MULT + P, box[3] * OUT_MULT + P]);
      }
    });
    if (!objects.some(function (o) { return /^clipart/.test(o.id) && (o.id in resolved); })) return null;
    return { objects: objects, resolved: resolved, rects: rects };
  }
  function split(entries) { // [[key, value]] with keys like "1463478-clipart3" -> { art, values }
    var art = null, values = {};
    entries.forEach(function (kv) {
      var m = /^(\d+)-(.+)$/.exec(kv[0]);
      if (m && (!art || art === m[1])) { art = m[1]; values[m[2]] = kv[1]; }
    });
    return { art: art, values: values };
  }

  function build(data) {
    var p = data.personalizations || {};
    var sv = split(Object.keys(p).map(function (k) { return [k, p[k]]; }));
    var pl = plan(sv.art, sv.values);
    if (!pl) return Promise.resolve(null);
    return render(pl.objects, pl.resolved, OUT_MULT).then(function (ours) {
      var check = data.previewImg ? img(data.previewImg).then(function (t) { return compare(ours, t, pl.rects); }, function () { return null; }) : Promise.resolve(null);
      return check.then(function (cmp) {
        stats.last = { art: sv.art, cmp: cmp };
        if (cmp && cmp.outside > 0.005) { stats.last.decision = 'layout-mismatch-neutral'; return ''; }
        stats.last.decision = cmp && cmp.inside > 0.002 ? 'replaced-stale-preview' : 'rebuilt';
        return ours.toDataURL('image/webp', 0.86);
      });
    });
  }

  // Cart and cart drawer: rebuild each dish preview from the line item's saved
  // personalization, so the image survives reloads, navigation, other tabs and devices.
  var cartCache = {}, cartRunning = false, cartAgain = false;
  function cartRows() {
    return document.querySelectorAll('tr.cart-item[id^="CartItem-"], [data-key][data-product-id]');
  }
  function setImg(imgEl, src, sig) {
    if (!imgEl || imgEl.getAttribute('data-flc-preview') === sig) return;
    var pic = imgEl.closest('picture');
    if (pic) pic.querySelectorAll('source').forEach(function (s) { s.remove(); });
    imgEl.removeAttribute('srcset'); imgEl.removeAttribute('sizes'); imgEl.removeAttribute('height');
    imgEl.style.height = 'auto';
    imgEl.setAttribute('data-flc-preview', sig);
    imgEl.setAttribute('data-fl-apod-thumb', imgEl.getAttribute('data-fl-apod-thumb') || sig);
    imgEl.src = src;
  }
  function previewForItem(item) {
    var props = item.properties || {};
    var sv = split(Object.keys(props).filter(function (k) { return k.indexOf('_apod-') === 0 && k !== '_apod-configuration_key'; })
      .map(function (k) { return [k.slice(6), props[k]]; }));
    var pl = sv.art ? plan(sv.art, sv.values) : null;
    if (!pl) return null;
    var sig = sv.art + '|' + JSON.stringify(sv.values);
    if (!cartCache[sig]) {
      cartCache[sig] = render(pl.objects, pl.resolved, OUT_MULT).then(function (c) { return c.toDataURL('image/webp', 0.86); });
      cartCache[sig].catch(function () { delete cartCache[sig]; });
    }
    return { sig: sig, tid: props['_thumbnail-id'] || props['thumbnail-id'] || null, p: cartCache[sig] };
  }
  function applyCart() {
    var rows = cartRows();
    if (!rows.length) return;
    if (cartRunning) { cartAgain = true; return; }
    [].forEach.call(rows, function (r) { r.__flcSeen = true; });
    cartRunning = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/?$/, '/') + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var jobs = [];
        cart.items.forEach(function (item, idx) {
          var pv;
          try { pv = previewForItem(item); } catch (e) { pv = null; }
          if (!pv) return;
          jobs.push(pv.p.then(function (src) {
            if (pv.tid) { try { localStorage.setItem(pv.tid, src); } catch (e) {} }
            var row = document.getElementById('CartItem-' + (idx + 1));
            var input = row && row.querySelector('[data-quantity-variant-id]');
            if (row && (!input || String(input.getAttribute('data-quantity-variant-id')) === String(item.variant_id))) setImg(row.querySelector('img.cart-item__image'), src, pv.sig);
            document.querySelectorAll('[data-key][data-product-id]').forEach(function (r) {
              if (r.getAttribute('data-key') === item.key) setImg(r.querySelector('img'), src, pv.sig);
            });
          }, function (e) { console.warn('FLC cart preview:', e); }));
        });
        return Promise.all(jobs);
      })
      .catch(function () {})
      .then(function () {
        cartRunning = false;
        if (cartAgain) { cartAgain = false; applyCart(); }
      });
  }
  var cartTimer = null;
  function scheduleCart() { clearTimeout(cartTimer); cartTimer = setTimeout(applyCart, 250); }
  ['cartQuantityUpdated', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, scheduleCart); window.addEventListener(ev, scheduleCart);
  });
  window.addEventListener('pageshow', scheduleCart);

  // Loading lock: keep the "Loading your preview…" cover blocking taps until the
  // AnywherePOD window has actually finished loading (browser load event), and never
  // reveal a half-loaded form if loading stalls.
  var SLOW_MSG = 'This is taking longer than usual. Please close this window and tap Personalize again.';
  function blocker(m) {
    var o = document.createElement('div');
    o.className = 'flc-apod-block';
    o.setAttribute('role', 'status');
    o.style.cssText = 'position:absolute;left:20px;right:20px;top:80px;bottom:20px;display:flex;align-items:center;justify-content:center;background:#fff;color:#333;font-size:16px;z-index:2147483647;text-align:center;padding:20px;pointer-events:auto;touch-action:none';
    o.textContent = SLOW_MSG;
    m.appendChild(o);
  }
  function lock() {
    var modals = document.querySelectorAll('.js_apod_modal');
    for (var i = 0; i < modals.length; i++) {
      var m = modals[i], f = m.querySelector('iframe');
      if (!f) continue;
      if (!f.__flcWatch) {
        f.__flcWatch = true;
        (function (m, f) {
          f.addEventListener('load', function () {
            f.__flcLoaded = true;
            var b = m.querySelector('.flc-apod-block');
            if (b) b.remove();
          });
        })(m, f);
      }
      var o = m.querySelector('.flc-apod-loading');
      if (o && o.style.pointerEvents !== 'auto') { o.style.pointerEvents = 'auto'; o.style.touchAction = 'none'; }
      if (!o && !f.__flcLoaded && m.dataset.flcLoading && !m.querySelector('.flc-apod-block')) blocker(m);
    }
  }
  var lockQueued = false;
  new MutationObserver(function () {
    if (lockQueued) return;
    lockQueued = true;
    Promise.resolve().then(function () { lockQueued = false; lock(); });
    if ([].some.call(cartRows(), function (r) { return !r.__flcSeen; })) scheduleCart();
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('message', function (e) {
    var data = e.data;
    if (e.origin !== ORIGIN || !data || data.event !== 'livePreviewSaved' || data.__flc) return;
    e.stopImmediatePropagation();
    var done = false;
    function forward(previewImg) {
      if (done) return; done = true;
      var next = Object.assign({}, data, { __flc: 1 });
      if (previewImg !== undefined) next.previewImg = previewImg;
      window.dispatchEvent(new MessageEvent('message', { data: next, origin: e.origin }));
      var all = document.querySelectorAll('input[name="properties[thumbnail-id]"]');
      var input = all.length ? all[all.length - 1] : null;
      if (input && previewImg && previewImg.indexOf('data:') === 0) remember(input.value);
      try { sessionStorage.setItem('flc_apod_guard_last', JSON.stringify(stats.last)); } catch (x) {}
    }
    var timer = setTimeout(function () { stats.last = { decision: 'timeout-neutral' }; forward(''); }, SAFETY_MS);
    var job;
    try { job = build(data); } catch (err) { job = Promise.reject(err); }
    job.then(function (preview) {
      clearTimeout(timer);
      forward(preview === null ? undefined : preview);
    }, function (err) {
      clearTimeout(timer);
      stats.last = { decision: 'error-neutral', error: String(err) };
      console.warn('FLC preview guard:', err);
      forward('');
    });
  }, true);
})();
